(function ($) {

  // Owl Carousels
  $carousel = $('.owl-carousel');
  $usp = $('.owl-uspslider');

 


  $carousel.each(function () {
    let items = 1,
      nav = true,
      dots = true,
      aOut = false,
      aIn = false,
      margin = 0,
      eager = 0,
      autoplay = false,
      timeout = 6000,
      drag = true,
      responsive = {};




    if ($(this).owlCarousel) {



      
    }

     if ($(this).is( $usp)) {   
      autoplay = true,
        timeout = 4000,
      responsive = {        
        0 : {items: 1 }, 
        768 : { items: 2 },
        1200 : { items: 4}
      };  
    }

    $(this).owlCarousel({
      lazyLoadEager: eager,
      items: items,
      autoplay: autoplay,
      loop: true,
      dots: dots,
      nav: nav,
      navText: [
        '<',
        '>'
      ],
      lazyLoad: true,
      animateOut: aOut,
      animateIn: aIn,
      smartSpeed: 1000,
      autoplayTimeout: timeout,
      margin: margin,
      responsive: responsive,
      autoplayHoverPause: true,
      mouseDrag: drag,
      touchDrag: drag
    });
  });
  // End


$('.sppcfbtn').on('click', function(){

  $('.bcontact-trigger-button').trigger('click');
  
});
  

})(jQuery);




